import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { RecipientTemplateFile } from './types/recipient-template-files.type';

/**
 * Fetches the recipient template files for a given mailing ID.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingId - The ID of the mailing for which to retrieve template files.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an
 * array of {@link RecipientTemplateFile}.
 * @throws Throws an error if the HTTP request fails.
 */
export const getRecipientTemplateFiles = async (instance: KyInstance, mailingId: number) => {
  try {
    return await instance
      .get<OperationResultWithData<RecipientTemplateFile[]>>(
        formatString(Uri.files.recipientTemplateFiles, mailingId.toString())
      )
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
